/**
 * v3 按钮 token：btn-primary / btn-secondary 是 custom.css 的底色与悬停动效类，
 * 其余为尺寸排版工具类，与首页 Hero 按钮同源。
 * Lg 版（px-8 py-4）用于 hero 主 CTA，标准版（px-6 py-3）用于卡内/表单/次级动作。
 */
export const btnPrimary =
  'btn-primary inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-white font-semibold text-base';
export const btnPrimaryLg =
  'btn-primary inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md text-white font-semibold text-base';
export const btnSecondary =
  'btn-secondary inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-indigo-600 font-semibold text-base';
export const btnSecondaryLg =
  'btn-secondary inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md text-indigo-600 font-semibold text-base';
